import { Box, Stack, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

export interface ITrainingProps {
	index?: number;
	url: string;
	header: ReactNode;
}

export const Training: FC<ITrainingProps> = ({ index, url, header }) => {
	return (
		<Stack direction="column" spacing={1} sx={{ height: 1.0 }}>
			<Typography variant="h5">
				{index ? `${index}. ` : ''}
				{header}
			</Typography>
			<Box component="iframe" src={url} sx={{ border: 'none', display: 'block', width: 1.0, height: 800 }} allowFullScreen></Box>
		</Stack>
	);
};
